import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "用户优惠券", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.customerCoupon.getList,
    columns: $data.columns,
    topButtons: $data.topButtons,
    selectionEnable: false,
    searchItems: $data.searchItems,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "searchItems"])]);
}